import $ from 'jquery';
import { TimelineLite, TweenMax } from 'gsap';
import { DragdealerInit } from './custom-slider';

export default function servicesEnable() {
  let container = $('.sec2__services');

  let hideContainer = $('.js-back-service'),
      showContainer = $('.js-front-service'),
      items = $('.service__content'),
      backTitle = $('.services__title'),
      backButton = $('.services__title .go_back'),
      links = $('.sec2__services .item a'),
      hideContainerInner = $('.js-back-service .sec2__services'),
      nextButton = $('.sec2 .right'),
      prevButton = $('.sec2 .left'),
      containerService = showContainer.find('.container__service'),
      buttons = $('.sec2 .project-nav');

  //  ON OPEN OUR service
  let isOpen, i, openTl;

  openTl = new TimelineLite({paused: true});

  openTl.to(hideContainerInner, 1, {y: -150, autoAlpha: 0})
      .set(hideContainer, {visibility: 'hidden', position: 'absolute'})
      .set(backButton, { className: '-=hide-arrow'})
      .set(showContainer, {display: 'block', position: 'static'})
      .set(containerService, {display: 'block'})
      .from(containerService, 1, { yPercent: 10, autoAlpha: 0, ease: Power1.easeOut, onComplete: initDrag})

  // if(window.innerWidth < 768) {
  //   let baseX;
  //   showContainer.on('touchstart', e => {
  //     baseX = e.originalEvent.touches[0].clientX;
  //     e.preventDefault();
  //   });
  //
  //   showContainer.on('touchend', e => {
  //     let newX = e.originalEvent.changedTouches[0].clientX;
  //
  //     if(newX - baseX > 15) {
  //       prev(e);
  //       // alert('prev');
  //     } else if(newX - baseX < -15) {
  //       next(e);
  //       // alert('next');
  //     }
  //   })
  // } else {
  //   nextButton.on('click', next);
  //   prevButton.on('click', prev);
  // }

  nextButton.on('click', next);
  prevButton.on('click', prev);


  container.click( function open(e) {

    e.preventDefault();

    showContainer.css('display', 'block');
    if(e.target.tagName === 'A') {
      showService(e.target.dataset.service);
    }

  });

  backButton.on('click touchstart', function(e) {
    e.preventDefault();
    openTl.reverse();
    buttons.removeClass('show');
  })


  function next(e) {
    e.preventDefault();

    if(i >= items.length - 1 ||
      TweenMax.isTweening(items[i]) ||
      TweenMax.isTweening(items[i + 1])
    ) {
      return;
    }
    let tl = new TimelineLite(),
        current = i + 1, prev = i;

    tl.to(items[prev], 0.5, {x: -200, autoAlpha: 0})
      .set(items[prev], {y: 0, className: '-=active'})
      .set(items[current], {autoAlpha: 0, x: 200, display: 'block'})
      .to(items[current], 0.7, {x: 0, autoAlpha: 1})
      .set(items[current], {className: '+=active', clearProps: 'all', onComplete: initDrag})
      .set(items[prev], {clearProps: 'all'})

    buttonText(current);

    i++;
  }

  function prev(e) {
    e.preventDefault();

    if(i <= 0 ||
      TweenMax.isTweening(items[i]) ||
      TweenMax.isTweening(items[i - 1])
    ) {
      return;
    }
    let tl = new TimelineLite(),
        current = i - 1, prev = i;

    tl.to(items[prev], 0.5, {x: 200, autoAlpha: 0})
      .set(items[prev], {y: 0, className: '-=active'})
      .set(items[current], {autoAlpha: 0, x: -200, display: 'block'})
      .to(items[current], 0.5, {x: 0, autoAlpha: 1})
      .set(items[current], {className: '+=active', clearProps: 'all', onComplete: initDrag})
      .set(items[prev], {clearProps: 'all'})

    buttonText(current);

    i--;
  }

  function initDrag() {
    // if(window.innerWidth > 767) {
    // } else {
    //   console.log('disable services slider');
    // }
    // DragdealerInit(i);
    // $(".service-content__mask").jScrollPane().data().jsp;
  }

  function showService(index) {
    // return;

    i = index - 1;


    items.removeClass('active');

    items.eq(i).addClass('active');
    
    let liCount = items.eq(1).find('.service__included-item').length;
    
    openTl.play();
      
    buttonText(i);

  }

  function buttonText(index) {
    if(index >= items.length - 1) {
      nextButton.removeClass('show');
    } else {
      nextButton.addClass('show');
      nextButton.text(items.eq(index + 1).find('.service__m_title').text());
    }

    if(index <= 0) {
      prevButton.removeClass('show');
    } else {
      prevButton.addClass('show');
      prevButton.text(items.eq(index - 1).find('.service__m_title').text());
    }
  }

}



// WEBPACK FOOTER //
// ./src/js/services.js